import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'

@Component({
    components: {
        AlertBanner
    }
})
export default class LaboratoryCancellationModalForm extends Vue {
    @Ref() readonly laboratoryCancellationModalForm!: any
    @Prop() readonly elementsNumber!: number

    show() {
        this.laboratoryCancellationModalForm.show()
    }

    hide() {
        this.laboratoryCancellationModalForm.hide()
    }
}
